import React from 'react';
import classes from './BlueButton.module.css';

const blueButton = (props) => {
    return (
        <button type="button" disabled={props.disabled} className={classes.Button} onClick={props.clicked}>{props.value}</button>
    );
}
export default blueButton;